"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomService = void 0;

/**
 * All our custom share services
 *
 * @packageDocumentation
 */
var CustomService;
exports.CustomService = CustomService;

(function (CustomService) {
  CustomService["whatsapp"] = "whatsapp";
  CustomService["instagram_stories"] = "instagram_stories";
  CustomService["copy_link"] = "copy_link";
})(CustomService || (exports.CustomService = CustomService = {}));